import React, { useState, InputHTMLAttributes, forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputMask } from '@react-input/mask';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import * as S from './styles';

type DynamicInputProps = {
  name: string;
  mask?: string;
  placeholder?: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  variant?: 'primary' | 'dynamic-filter' | 'date-input';
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, DynamicInputProps>(
  (
    {
      name,
      mask,
      placeholder,
      type = 'text',
      className = '',
      disabled = false,
      variant = 'primary',
      onPaste,
      ...rest
    },
    ref,
  ) => {
    const {
      control,
      register,
      formState: { errors },
    } = useFormContext();
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === 'password';

    return (
      <S.InputContainer>
        {mask ? (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <InputMask
                {...field}
                component={S.PrimaryInput}
                mask={mask.replace(/9/g, '_').replace(/\*/g, '#')}
                replacement={{ _: /\d/, '#': /[A-Za-z0-9]/ }}
                disabled={disabled}
                onPaste={onPaste}
                ref={input => {
                  field.ref(input);
                  if (typeof ref === 'function') ref(input);
                  else if (ref) ref.current = input;
                }}
                type={isPassword && showPassword ? 'text' : type}
                placeholder={placeholder}
                className={className}
                variant={variant}
              />
            )}
          />
        ) : (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <S.PrimaryInput
                {...field}
                {...rest}
                ref={ref}
                type={isPassword && showPassword ? 'text' : type}
                placeholder={placeholder}
                className={className}
                disabled={disabled}
                variant={variant}
              />
            )}
          />
        )}
        {isPassword && (
          <S.RightContent onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? (
              <AiOutlineEyeInvisible color="#7c7e80" size={20} />
            ) : (
              <AiOutlineEye color="#7c7e80" size={20} />
            )}
          </S.RightContent>
        )}
        {errors[name] && (
          <S.ErrorText className="required-message">
            {errors[name]?.message?.toString() || 'Campo obrigatório'}
          </S.ErrorText>
        )}
      </S.InputContainer>
    );
  },
);

Input.displayName = 'Input';
